import React, { useContext, useMemo } from "react"
import API from "../../utils/API"
import Sweetalert from "../../utils/Sweetalert"
import ButtonCollapse from "../ButtonCollapse"
import DiffusionAdCardItem from "./DiffusionAdCardItem"
import LoadingCard from "../LoadingCard"
import DiffusionAdCardFolder from "./DiffusionAdCardFolder"
import UserContext from "../../UserContext"
import { openSchedulerModal } from "./Scheduler/SchedulerModal"

export default function DiffusionAdCard({
  ads,
  adPaths,
  loaded,
  currentAdPath,
  setCurrentAdPath,
  totemSelected,
  addAdToSelectedTotem,
}) {
  const userContext = useContext(UserContext)

  const adsAvailable = useMemo(() => {
    if (!totemSelected) return []
    const totemAdIds = totemSelected.ads.map((ad) => ad.id)
    return ads.filter(
      (ad) => !totemAdIds.includes(ad.id) && currentAdPath === ad.adPathId
    )
  }, [ads, currentAdPath, totemSelected])

  const adPathsFiltered = useMemo(() => {
    return adPaths.filter((adPath) => currentAdPath === adPath.parent)
  }, [adPaths, currentAdPath])

  const getParentAdPathId = (currentAdPath) => {
    const parentPath = adPaths.find((adPath) => adPath.id === currentAdPath)

    return parentPath ? parentPath.parent : null
  }

  const selectAd = async (ad) => {
    const maxDuration = totemSelected.team_totem.duration
    const sendRequest = async (ad, nVDuration) => {
      if (ad.duration + nVDuration > maxDuration)
        Sweetalert.fireWarningToast(
          "Cette ressource dépasse la limite de " + maxDuration + "s de diffusion par boucle autorisée pour ce totem"
        )
      else {
        const planification = await openSchedulerModal()
        if (planification === false) return
        API.POST(
          "/totem/" + totemSelected.id + "/ad",
          { id: ad.id, duration: nVDuration, planification },
          (response) => {
            Sweetalert.fireSuccessToast(response.data.message)
            addAdToSelectedTotem(ad, nVDuration, planification)
          }
        )
      }
    }

    if (ad.adTypeId !== 1)
      Sweetalert.askNumber(
        "Durée d'affichage",
        "Définissez la durée pendant laquelle cette ressource s'affiche par boucle",
        1,
        maxDuration,
        `Durée en secondes (Entre 1 et ${maxDuration}s)`,
        (response) => sendRequest(ad, parseInt(response.value))
      )
    else sendRequest(ad, 0)
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Mes ressources</h3>
        <div className="card-tools">
          <ButtonCollapse />
        </div>
      </div>
      <div className="card-body p-0" style={{ display: "block" }}>
        <LoadingCard loaded={loaded}>
          {totemSelected ? (
            <>
              {currentAdPath ? (
                <DiffusionAdCardFolder
                  folderId={getParentAdPathId(currentAdPath)}
                  folderName="Retour"
                  onClick={setCurrentAdPath}
                />
              ) : (
                userContext.canvaLink && (
                  <DiffusionAdCardFolder
                    folderId={"canva"}
                    folderName="Mes ressources Canva"
                    onClick={setCurrentAdPath}
                  />
                )
              )}
              {adPathsFiltered.length > 0 &&
                adPathsFiltered.map((folder) => (
                  <DiffusionAdCardFolder
                    key={folder.id}
                    folderId={folder.id}
                    folderName={folder.name}
                    onClick={setCurrentAdPath}
                  />
                ))}
              {adsAvailable.length > 0 &&
                adsAvailable.map((ad) => <DiffusionAdCardItem key={ad.id} ad={ad} onClick={selectAd} />)}
              {adPathsFiltered.length === 0 && !currentAdPath && adsAvailable.length === 0 && (
                <div className="alert alert-info m-3">
                  <i className="icon fas fa-info" /> Aucune ressource disponible
                </div>
              )}
            </>
          ) : (
            <div className="alert alert-info m-3">
              <i className="icon fas fa-info" /> Veuillez sélectionner un totem
            </div>
          )}
        </LoadingCard>
      </div>
    </div>
  )
}
